import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { EN_CALENDAR, ES_CALENDAR } from "common/utils/date"
import { withFormik } from "formik"
import { addLocale } from "primereact/api"
import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const FechaVencimiento = ({
  values,
  handleSubmit,
  onHide,
  handleChange,
  isValid,
}: {
  values: {
    fechaVencimiento: Date
    fechaEmision: Date
  }
  handleSubmit: () => void
  onHide: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChange: $TSMigrationFixMe
  isValid: boolean
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  addLocale("es", ES_CALENDAR)
  addLocale("en", EN_CALENDAR)

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='tw-mb-2 tw-flex tw-flex-col'>
        <label htmlFor='calendar'>
          {t("crear.facturaRec.vencimientoDateLabel")}
        </label>
        <Calendar
          id='calendar'
          name='fechaVencimiento'
          value={values.fechaVencimiento}
          locale={language}
          dateFormat='dd/mm/yy'
          minDate={values.fechaEmision}
          mask='99/99/9999'
          onChange={handleChange}
          showIcon
          baseZIndex={2302}
        />
      </div>
      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer hover:!tw-shadow'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          disabled={!isValid}
          className='!tw-bg-primary tw-h-10 tw-flex tw-justify-center tw-items-center hover:!tw-shadow hover:!tw-bg-primary-over'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  fechaVencimiento: Yup.string().min(3).required(),
})

const FormFechaVencimiento = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapPropsToValues: ({
    fechaVencimiento,
    fechaEmision,
  }: $TSMigrationFixMe) => ({
    fechaVencimiento: new Date(fechaVencimiento),
    fechaEmision: new Date(fechaEmision),
  }),
  handleSubmit: ({ fechaVencimiento }, { props }) => {
    props.onChange(fechaVencimiento)
    props.onHide()
  },
})(FechaVencimiento)

export default FormFechaVencimiento
